import React from 'react'
import styled from 'styled-components'
import palette from 'core-system/Themes/palette'
import { StaticAssetsUrl } from 'redux/config/services/Constants'

const Container = styled.div`
  background-color: #ffffff;
  border: 1px solid ${palette.grey.grey300};
  border-radius: 0.5rem;
  background-color: white;
  overflow: hidden;
`

const Img = styled.img`
  width: 100%;
  object-fit: cover;
`

const SummaryContainer = styled.div`
  padding: 2rem 1rem;
`

interface ProgramSummaryContainerProps {
  children: React.ReactNode
}

const ProgramSummaryContainer = ({
  children,
}: ProgramSummaryContainerProps) => {
  return (
    <Container>
      <Img src={`${StaticAssetsUrl}/onboarding/program_summary.jpeg`} />
      <SummaryContainer>{children}</SummaryContainer>
    </Container>
  )
}

export default React.memo(ProgramSummaryContainer)
